<template>
    <div id="header-warms" class="warms">
        <div
                v-for="el, key in elements"
                :key="key"
                class="absolute rounded-full"
                :style="getWarmStyle(el)"
        ></div>
    </div>
</template>

<script>
    export default {
        name: "HeaderWarms",
        props: {
            animation: {
                type: Boolean,
                default: true,
            },
            elements: {
                type: Array,
                default: () => {
                    return [
                        {x: 0, y: 0, w: 1, h: 1, c: 'violet', fy: -6},
                        {x: 30, y: -6, w: 4, h: 1, c: 'violet', fx: 4, fw: 4},
                        {x: 15, y: -4, w: -6, h: 1, c: 'black', fx: 4, fw: 3},
                        {x: 2, y: -3, w: 0, h: 1, c: 'violet', ab: 0.5, fw: 3, fy: -1.5},



                        {x: 0, y: -4, w: 1, h: 5, c: 'black', fy: -1, fh: 2},
                        {x: 2, y: -1, w: 1, h: 2, c: 'violet',fy: -5, fh: 6},
                        {x: 1, y: 1, w: 1, h: 1, c: 'orange'},
                        {x: 0, y: 2, w: 1, h: 4, c: 'orange'},
                        {x: 2, y: 2, w: 1, h: 1, c: 'blue'},

                        {x: 0, y: 8, w: 1, h: 1, c: 'blue', fs: 0, ab: 0.4, ae: 0.7},
                        {x: 2.5, y: 5, w: 1, h: 4, c: 'blue', fh: 0, fy: 6, ab: 0.2, ae: 0.85},
                        {x: 0, y: 11, w: 4, h: 1, c: 'blue-outline', fw: 0, ab: 0.2, ae: 0.5},

                        {x: 0, y: 13, w: 1, h: 3.5, c: 'blue', fh: 0, ab: 0.1, ae: 0.35},
                        {x: 0, y: 19.5, w: 1, h: 1, c: 'blue-outline', fy: 15.5, fs: 0, ae: 0.2},
                        {x: 2, y: 15, w: 2, h: 1, c: 'blue', fw: 0, ab: 0.05, ae: 0.3},
                        {x: 3, y: 18.5, w: 1, h: 4.5, c: 'blue-outline', fh: 0, ab: 0, ae: 0.3},


                        {x: 5, y: -4, w: 1, h: 9, c: 'blue', fh: 5, fy: 0},
                        {x: 7, y: 4, w: 1, h: 2, c: 'orange'},
                        {x: 9.25, y: 5, w: 1, h: 1, c: 'blue', ab: 0, fs: 0, ae: 0.6},
                        {x: 10.25, y: 3, w: 2, h: 1, c: 'blue', ab: 0.4, fw: 0, ae: 0.7},

                        {x: 5, y: 7, w: 6, h: 1, c: 'blue', fw: 0, fx: 5, ae: 0.75},
                        {x: 8, y: 9, w: 4, h: 1, c: 'blue', fw: 0, fx: 8, ae: 0.65},
                        {x: 6, y: 10.5, w: 1, h: 1, c: 'blue-outline', fs: 0, ae: 0.65},
                        {x: 5, y: 12, w: 2, h: 1, c: 'blue', fw: 0, ae: 0.5},
                        {x: 9, y: 12, w: 1, h: 1, c: 'blue', fs: 0, ae: 0.5},

                        {x: 7, y: 14.25, w: 6, h: 1, c: 'blue-outline', fw: 0, fx: 10, ae: 0.3},
                        {x: 5, y: 14.25, w: 1, h: 4, c: 'blue', fh: 0, ae: 0.3},
                        {x: 9, y: 17, w: 5, h: 1, c: 'blue', fw: 0, fx: 20, ae: 0.4}
                    ];
                }
            },
        },
        data() {
            return {
                scrollMax: 650,
                p: 0,
            };
        },
        computed: {
            f() {
                return this.animation ?
                    2 - 1.75 * this.p :
                    2;
            },
            ox() {
                return -this.p / 2;
            },
            oy() {
                return this.animation ?
                    1 + 1.5 * this.p :
                    0;
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll () {
                this.p = Math.min(window.scrollY, this.scrollMax) / this.scrollMax;
            },
            getWarmStyle(el) {

                const s = 1;

                const ab = el.hasOwnProperty('ab') ?
                    el.ab :
                    0;
                const ae = el.hasOwnProperty('ae') ?
                    Math.min(1, el.ae * 1) :
                    1;

                const p = this.animation ?
                    Math.max(0, this.p - ab) / (ae - ab) :
                    0;

                const left = el.hasOwnProperty('fx') ?
                    this.f * ( el.x + p * ( el.fx - el.x ) ) + this.ox :
                    this.f * el.x + this.ox;

                const top = el.hasOwnProperty('fy') ?
                    this.f * ( el.y + p * ( el.fy - el.y ) ) + this.oy :
                    this.f * el.y + this.oy;

                const width = el.hasOwnProperty('fw') ?
                    this.f * ( el.w + p * ( el.fw - el.w ) ) :
                    this.f * el.w;

                const height = el.hasOwnProperty('fh') ?
                    Math.max(0, this.f * ( el.h + p * ( el.fh - el.h ) )) :
                    this.f * el.h;

                let scale = el.hasOwnProperty('fs') ?
                    Math.max(0, s + p * (el.fs - s)) :
                    s;


                if ((el.hasOwnProperty('ae')) && (p > 0.6)) {
                    let r = (-5 * p + 4);
                    scale = Math.max(0, scale * r);
                }

                const borderColor = this.getBorderColor(el.c);

                let r = 0;
                if (el.hasOwnProperty('r')) {
                    r = el.r * p;
                }

                let style = {
                    transform: 'translateX(' + left + 'rem) translateY(' + top + 'rem) scale(' + scale + ') rotateZ(' + r + 'deg)',
                    width: width + 'rem',
                    height: height + 'rem',
                    'background-color': this.getBackgroundColor(el.c),
                };

                if (borderColor !== false) {
                    style['border'] = '1px solid ' + borderColor;
                }

                return style;
            },
            getBorderColor(symbol) {
                switch (symbol) {
                    case 'blue-outline': {
                        return '#0000FF';
                    }
                }
                return false;
            },
            getBackgroundColor(symbol) {
                switch (symbol) {
                    case 'black': {
                        return '#424242';
                    }
                    case 'violet': {
                        return '#8350FF';
                    }
                    case 'orange': {
                        return '#FF8939';
                    }
                    case 'blue': {
                        return '#0000FF';
                    }
                }
                return 'transparent';
            }
        }
    }
</script>

<style scoped>

</style>